import React from "react";
import OperationsShell from "@/components/operations/OperationsShell";
import InstallerTasks from "@/pages/InstallerTasks";

/**
 * FIELD-001C · Operations task list wrapper.
 *
 * Reuses the canonical `<InstallerTasks />` implementation (it is the
 * app-wide task list — the "installer" prefix is legacy) but mounts it
 * inside `<OperationsShell>` so Operations users can drill into
 * `/operations/tasks?engineer_id=…&scope=…` from the Workload counters
 * WITHOUT hitting the `role="installer"` guard on the legacy route.
 *
 * The `embedded` prop tells the inner component to skip its own
 * `<InstallerShell>` so we don't render a shell inside a shell.
 * Every filter / URL param / permission check inside `InstallerTasks`
 * is role-aware already: `manage_projects` operators keep full
 * bulk-select + engineer filter access, and field users landing here
 * (they shouldn't, but the guard is defensive) still get the
 * assigned-only "My tasks" view.
 */
export default function OperationsTasks() {
    return (
        <OperationsShell>
            <InstallerTasks embedded />
        </OperationsShell>
    );
}
